import { BMEmptyState } from "@traveloka/district-bloom";
import { BMEmptyStateProps } from "@traveloka/district-bloom/js/components/EmptyState/BMEmptyState";
import { useMemo } from "react";
import { useWindowDimensions } from "react-native";
import BMView from "../../View/BMView";
import { ErrorSectionItemLargeProps } from "./types";
import {
  getErrorSectionButtons,
  getErrorSectionCustomImage,
  getErrorSectionIllustration,
} from "./utils";

const DESKTOP_MAX_WIDTH = 494;

export default function ErrorSectionLarge({
  title,
  caption,
  button,
  style,
  image,
  illustration,
}: ErrorSectionItemLargeProps) {
  const emptyStateProps: BMEmptyStateProps = useMemo(() => {
    return {
      title: title ?? "Something went wrong",
      description:
        caption ??
        "Sorry, our system encounters a bit of trouble. Please check again later.",
      illustration: !image
        ? getErrorSectionIllustration(illustration)
        : undefined,
      customImage: getErrorSectionCustomImage(image),
      ...getErrorSectionButtons(button),
    };
  }, [title, caption, button, image, illustration]);

  const { width } = useWindowDimensions();
  const containerWidth = useMemo(() => {
    return width > DESKTOP_MAX_WIDTH ? DESKTOP_MAX_WIDTH : "100%";
  }, [width]);

  return (
    <BMView flex align="center" justify="center" style={style}>
      <BMView style={{ width: containerWidth }}>
        <BMEmptyState {...emptyStateProps} />
      </BMView>
    </BMView>
  );
}
